import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { getAllProgress, formatDateForStorage } from "@/utils/gameProgress";
import { PlayCircle } from "lucide-react";

export function ResumeGameBanner() {
  const [inProgressPuzzle, setInProgressPuzzle] = useState<{ date: string; guesses: number } | null>(null);

  useEffect(() => {
    const allProgress = getAllProgress();
    
    // Find any incomplete game with guesses (not completed, has at least one guess)
    const incomplete = Object.entries(allProgress).find(
      ([_, progress]) => !progress.completed && progress.guesses.length > 0
    );
    
    if (incomplete) {
      setInProgressPuzzle({
        date: incomplete[0],
        guesses: incomplete[1].guesses.length,
      });
    }
  }, []);

  if (!inProgressPuzzle) return null;

  // Format date for display (e.g., "November 9, 2025")
  const displayDate = new Date(inProgressPuzzle.date + "T12:00:00").toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="max-w-4xl mx-auto px-4 py-4">
      <div className="bg-primary/10 border border-primary/30 rounded-lg p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-start gap-3">
          <PlayCircle className="w-6 h-6 text-primary shrink-0 mt-0.5" />
          <div>
            <p className="font-semibold text-foreground">You have an unfinished puzzle!</p>
            <p className="text-sm text-muted-foreground">
              {displayDate} • {inProgressPuzzle.guesses} {inProgressPuzzle.guesses === 1 ? "guess" : "guesses"} made
            </p>
          </div>
        </div>
        <Link to={`/puzzle/${inProgressPuzzle.date}`}>
          <Button className="whitespace-nowrap">
            Resume Game →
          </Button>
        </Link>
      </div>
    </div>
  );
}
